import { z } from 'zod';

import { nullishDefault } from '../../../utils/nullableDefault';

export const BeschaeftigungHausfrau = z.object({
    sonstigesEinkommenMonatlich: nullishDefault(z.number()),
});

// hausfrau: yup
// .object()
// .shape({
// 	sonstigesEinkommenMonatlich: yup.number().optional().nullable().default(null),
// })
// .notRequired()
// .default(undefined)
// .when('beschaeftigungsart', {
// 	is: 'HAUSFRAU',
// 	otherwise: (s) => s.strip(),
// 	then: (s) => s.optional().nullable().default(null),
// }),
